module.exports = __webpack_public_path__ + "img/11.054f8b85.png";